import React from "react";
import Expander from "../../Expander";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import helpers from "../../../common/utils/utils";
import PublicationLinks from "../../Publications/components/PublicationLinks";

const chemicalUrl = "https://www.pharmgkb.org/chemical/";

const getClinicalAnnotationsRow = (item, key, expandRow) => {
  const rows = [];
  if (item.chemical_relations && item.chemical_relations.length > 0) {
    const chemicalRelationsLength = item.chemical_relations.length;
    item.chemical_relations.forEach((i, j) => {
      const v = `${key}_${j}`;
      const row = (
        <tr
          className="tw-border-t tw-border-solid tw-border-gray-200 tw-break-words"
          key={v}
        >
          <td className="tw-text-left tw-p-2.5">
            {i.id && i.name ? (
              <a href={getVarsoUrl(chemicalUrl + i.id)} target="_blank">
                {helpers.capitalizeFirstLetter(i.name.toLowerCase())}
              </a>
            ) : (
              "-"
            )}
          </td>
          {j === 0 && (
            <td
              className="tw-text-left tw-p-2.5"
              rowSpan={chemicalRelationsLength}
            >
              {item.id ? (
                <a href={getVarsoUrl(item.url)} target="_blank">
                  {item.id}{" "}
                </a>
              ) : (
                "-"
              )}
            </td>
          )}
          {j === 0 && (
            <td
              className="tw-text-center tw-p-2.5"
              rowSpan={chemicalRelationsLength}
            >
              {item.annotation_type
                ? helpers.capitalizeFirstLetter(
                    item.annotation_type.toLowerCase()
                  )
                : "-"}
            </td>
          )}
          {j === 0 && (
            <td
              className="tw-text-center tw-p-2.5"
              rowSpan={chemicalRelationsLength}
            >
              {item.ethnicity
                ? helpers.capitalizeFirstLetter(item.ethnicity.toLowerCase())
                : "-"}
            </td>
          )}
          {j === 0 && (
            <td
              className="tw-text-center tw-p-2.5"
              rowSpan={chemicalRelationsLength}
            >
              {item.level_of_evidence || "-"}
            </td>
          )}
          {j === 0 && (
            <td
              className="tw-text-center tw-p-2.5"
              rowSpan={chemicalRelationsLength}
            >
              {(item.score !== null && item.score) || "-"}
            </td>
          )}
          {j === 0 && (
            <td
              className="tw-text-center tw-p-2.5"
              rowSpan={chemicalRelationsLength}
            >
              {item.pub_med_references ? (
                <PublicationLinks ids={item.pub_med_references} />
              ) : (
                "-"
              )}
            </td>
          )}
          {j === 0 && (
            <td rowSpan={chemicalRelationsLength} className="tw-p-2.5">
              {item.annotation_text
                ? item.annotation_text.map((annotation, k) => {
                    const m = `annotation-${key}-${k}`;
                    return (
                      <div key={m} className="tw-mb-4">
                        {annotation}
                      </div>
                    );
                  })
                : "-"}
            </td>
          )}
          {j === 0 && (
            <td
              className="tw-text-center tw-p-2.5"
              rowSpan={chemicalRelationsLength}
            >
              {item.evidence ? (
                <a onClick={() => expandRow(item)}>
                  {item.expanded ? "Collapse evidence" : "Expand evidence"}
                </a>
              ) : (
                "-"
              )}
            </td>
          )}
        </tr>
      );
      rows.push(row);
    });
  }

  if (item.expanded) {
    const expandedRow = (
      <tr
        className="tw-border-t tw-border-solid tw-border-gray-200 tw-break-words"
        key={`expanded_${key}`}
      >
        <td className="tw-text-left tw-p-2.5" colSpan="9">
          <h5>Evidence table</h5>
          <table className="tw-w-full">
            <thead>
              <tr>
                <th className="tw-p-2.5 tw-border-b tw-border-tableBorder">
                  ID
                </th>
                <th className="tw-p-2.5 tw-border-b tw-border-tableBorder">
                  Type
                </th>
                <th className="tw-p-2.5 tw-border-b tw-border-tableBorder">
                  Score
                </th>
                <th className="tw-p-2.5 tw-border-b tw-border-tableBorder">
                  Summary
                </th>
              </tr>
            </thead>
            <tbody>
              {item.evidence.map((i) => {
                let id = i.evidence_id;
                if (i.evidence_id && i.evidence_url) {
                  id = (
                    <a href={getVarsoUrl(i.evidence_url)} target="_blank">
                      {i.evidence_id}
                    </a>
                  );
                }
                return (
                  <tr>
                    <td className="tw-p-2.5">{id || "-"}</td>
                    <td className="tw-p-2.5">{i.evidence_type || "-"}</td>
                    <td className="tw-p-2.5">
                      {(i.score !== null && i.score) || "-"}
                    </td>
                    <td className="tw-p-2.5">{i.summary || "-"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </td>
      </tr>
    );
    rows.push(expandedRow);
  }
  return rows;
};

export const getClinicalAnnotationsTable = (items, expandRow) => {
  let result = null;
  const rows = [];

  items.forEach((item, key) => {
    rows.push(getClinicalAnnotationsRow(item, key, expandRow));
  });
  result = (
    <table className="tw-w-full tw-border-collapse tw-border-t tw-border-solid tw-border-gray-200 tw-break-words tw-font-saphetor">
      <thead>
        <tr>
          <th className="tw-text-center tw-p-2.5 tw-border-b tw-border-tableBorder">
            Drugs
          </th>
          <th className="tw-text-center tw-p-2.5 tw-border-b tw-border-tableBorder">
            Clinical Annotation ID
          </th>
          <th className="tw-text-center tw-p-2.5 tw-border-b tw-border-tableBorder">
            Annotation Type
          </th>
          <th className="tw-text-center tw-p-2.5 tw-border-b tw-border-tableBorder">
            Ethnicity
          </th>
          <th className="tw-text-center tw-p-2.5 tw-border-b tw-border-tableBorder">
            <a
              href={getVarsoUrl("https://www.pharmgkb.org/page/clinAnnLevels")}
              target="_blank"
            >
              Level Of Evidence
            </a>
          </th>
          <th className="tw-text-center tw-p-2.5 tw-border-b tw-border-tableBorder">
            Score
          </th>
          <th className="tw-text-center tw-p-2.5 tw-border-b tw-border-tableBorder">
            Publications
          </th>
          <th className="tw-text-center tw-w-2/5 tw-p-2.5 tw-border-b tw-border-tableBorder">
            Annotation
          </th>
          <th className="tw-text-center tw-p-2.5 tw-border-b tw-border-tableBorder">
            Evidence
          </th>
        </tr>
      </thead>
      <Expander showMore="10" columns="9" component="tbody">
        {rows}
      </Expander>
    </table>
  );
  return result;
};
